import template from './release_notes.html';
import tr from '../../lib/default-translator.js';

class ReleaseNotesViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}
}

class ReleaseNotesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReleaseNotesViewModel(this);
	}

	init()
	{
		document.title = tr('Release Notes');
		window.current_page_title(tr('Release Notes'));
	}
}

export default {
	route: '[/]settings/release-notes',
	page_class: ReleaseNotesPage,
	template: template,
	template_filename: 'translation/release_notes'
};
